import { types } from '../actions/types';

const INITIAL_STATE = {
    providerCompanies: null,
    providers: [],
    accountAdmins: [],
    staffAdmins: [],
    providerInfo: {},
    companyInfo: null,
    services: {},
    selectedService: null,
    selectedStaff: null,
    currentWizardStep: 0,
    clientToAdd: null, //TODO: DELETE IF NOT BEING USED
    tempActivationCode: null,
    isDialogOpen: false,
    dialogType: null,
    formSubmissionSuccessful: false,
    formattedUserData: null,
    formattedProviderData: null,
    waitingOnCompanySetupFormData: false,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.GET_ALL_PROVIDER_COMPANIES:
            return {
                ...state, providerCompanies: action.payload
            }
        case types.GET_DB_PROVIDERS:
            return {
                ...state, providers: action.payload
            }
        case types.GET_COMPANY_INFO:
            return{
                ...state,
                companyInfo: action.payload.companyInfo,
                providers: action.payload.providers,
                accountAdmins: action.payload.accountAdmins,
                staffAdmins: action.payload.staffAdmins
            }
        case types.GET_SERVICES:
            return{
                ...state, services: action.payload
            }
        case types.SELECT_STAFF:
            return{
                ...state,  selectedStaff : action.payload
            }
        case types.SELECT_SERVICE:
            return{
                ...state,  selectedService : action.payload
            }
        case types.RESET_SELECTIONS:
            return{
                ...state, selectedService: null, selectedStaff: null, formSubmissionSuccessful: false
            }
        case types.CHANGE_DIALOG_STATUS:
            return{
                ...state, currentWizardStep: action.payload.step, isDialogOpen: action.payload.open, dialogType: action.payload.type
            }
        case types.CHANGE_WIZARD_STEP:
            return{
                ...state, currentWizardStep: action.payload
            }
        case types.FIND_CLIENT_BY_EMAIL:
            let clientToAdd; //TODO: DELETE IF NOT BEING USED
            let newPage = 1;
            if( action.payload ) newPage = 4;
            return {
                ...state, currentWizardStep: newPage
            }
        case types.SET_ACTIVATION_CODE:
            return {
                ...state, tempActivationCode: action.payload
            }
        case types.FORM_SUBMISSION_SUCCESSFUL:
            return {
                ...state, formSubmissionSuccessful: action.payload
            }
        case types.SETUP_ADMIN_DATA:
            return {
                ...state,
                formattedUserData: action.payload.formattedUserData,
                formattedProviderData: action.payload.formattedProviderData,
                waitingOnCompanySetupFormData: action.payload.waitingOnCompanySetupFormData
            }
        case types.COMPANY_CREATION_SUCCESS:
            return {
                ...state, companyInfo: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/company-reducer.js